module.exports = __webpack_public_path__ + "img/Ballast-Drawing-FG-584x584.a296ff79.webp";